import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Refresh the location of places
 *
 * @private
 */
export const refreshLocations = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/place/refreshLocations', async (_params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/place/refreshLocations', {
      category: 'rpc',
      type: 'rpc/place/refreshLocations',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {refreshLocations}`,
      { tags: ['rpc', 'place'] },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Refresh place locations failed`,
      error,
    })
  }
})
